export const MAX_USER_NAME_LENGTH = 30;

export function clampUserName(name) {
    return String(name || '').trim().slice(0, MAX_USER_NAME_LENGTH);
}
